module.exports = __webpack_public_path__ + "img/aoss.ab26160f.png";